// extracted by mini-css-extract-plugin
export default {"divider":"main_divider__T1nvi"};